import actionConsts from '../../constants/actions';

const gameState = (state = [], action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return {
                ...state,
                isHelpMenuOpen: false,
                tempMailStorage: action.payload // this is used to store mails temporarily while in tutorial mode
            }

        case actionConsts.SET_GAME_OVER_FLAG:
            return {
                ...state,
                isGameOver: true
            }

        case actionConsts.INCOMING_CALL_NOTIFICATION:
            return {
                ...state,
                isIncomingCall: true
            };
        case actionConsts.CALL_RECIEVED:
            return {
                ...state,
                isIncomingCall: false
            };

        case actionConsts.END_CALL:
            return {
                ...state,
                currentCallId: null
            };
        case actionConsts.ADD_SHOW_CALL_FLAG:
            if (!action.payload.saveCall) {
                return {
                    ...state,
                    currentCallId: action.payload.call.id
                }
            }
            return state

        case actionConsts.OPEN_HELP_MENU:
            return {
                ...state,
                isHelpMenuOpen: true
            }

        case actionConsts.CLOSE_HELP_MENU:
            return {
                ...state,
                isHelpMenuOpen: false
            }

        case actionConsts.INCOMING_MEETING_NOTIFICATION:
            return {
                ...state,
                isIncomingMeeting: true,
                countdown: 5
            };

        case actionConsts.COUNT_DOWN_TIMER:
            return {
                ...state,
                countdown: state.countdown - 1
            }

        case actionConsts.MEETING_RECIEVED:
            return {
                ...state,
                isIncomingMeeting: false,
                countdown: 5
            };

        case actionConsts.END_MEETING:
            return {
                ...state,
                currentMeetingId: null
            };

        case actionConsts.ADD_SHOW_MEETING_FLAG:
            if (!action.payload.saveCall) {
                return {
                    ...state,
                    currentMeetingId: action.payload.meeting.id
                }
            }
            return state

        case actionConsts.SHOW_MEETING_NOTIFICATION:
            return {
                ...state,
                showMeetingNotification: true,
                meetingTimeLeft: action.payload
            }

        case actionConsts.HIDE_MEETING_NOTIFICATION:
            return {
                ...state,
                showMeetingNotification: false
            }

        default:
            return state;
    }
};

export default gameState;


// WEBPACK FOOTER //
// /src/reducers/uiState/gameState.js